var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-v3" },
    [
      _c(
        "el-row",
        {
          staticClass:
            "top-section card-style load-up card-softstyle grey-card-softstyle",
          attrs: { align: "middle" }
        },
        [
          _c("el-col", { attrs: { xs: 24, sm: 12, lg: 6 } }, [
            _c("div", { staticClass: "profile-img" }, [
              _c(
                "span",
                { staticStyle: { "font-size": "7em", color: "White" } },
                [_c("i", { staticClass: "fas fa-globe-americas" })]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 12, lg: 18 } },
            [
              _c("el-col", { attrs: { xs: 24, sm: 24, lg: 8 } }, [
                _c(
                  "div",
                  { staticClass: "extra-margin remove-margin-if-small-screen" },
                  [
                    _vm.data
                      ? _c("div", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$store.getters.account
                                ? _vm.$store.getters.account.userName
                                : "-"
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.merchant.organizationName"))
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { xs: 24, sm: 24, lg: 8 } }, [
                _c("div", { staticClass: "extra-margin" }, [
                  _vm.data
                    ? _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.data.lastLoginTime))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("dashboard.lastLoginTime")))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { xs: 24, sm: 24, lg: 8 } }, [
                _c("div", { staticClass: "extra-margin" }, [
                  _vm.data
                    ? _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.data.lastLoginIp))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("dashboard.lastLoginIp")))
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "body-row", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "info-section", attrs: { xs: 24, sm: 24, lg: 10 } },
            [
              _c("div", { staticClass: "card-style load-up card-softstyle" }, [
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.data
                        ? _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.data.organizationCode || "-") +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("dashboard.merchant.organizationCode")
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.7em",
                            color: "CadetBlue"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-building" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.data
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              style:
                                _vm.orgStatus.orgType === "success"
                                  ? "color: green"
                                  : "color: red"
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.orgStatus.orgStatus) +
                                  "\n                  "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("dashboard.merchant.organizationStatus")
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.orgStatus
                      ? _c("div", { staticClass: "right" }, [
                          _c(
                            "span",
                            {
                              style:
                                _vm.orgStatus.orgType === "success"
                                  ? "font-size: 1.7em; color: green"
                                  : "font-size: 1.7em; color: red"
                            },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.orgStatus.orgType === "success",
                                    expression:
                                      "orgStatus.orgType === 'success'"
                                  }
                                ],
                                staticClass: "fas fa-check-circle"
                              }),
                              _vm._v(" "),
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.orgStatus.orgType !== "success",
                                    expression:
                                      "orgStatus.orgType !== 'success'"
                                  }
                                ],
                                staticClass: "fas fa-times-circle"
                              })
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.data
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              style:
                                _vm.approvalStatus.approvalType === "success"
                                  ? "color: green"
                                  : "color: red"
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.approvalStatus.approvalStatus) +
                                  "\n                  "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("dashboard.merchant.approvalStatus")
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.approvalStatus
                      ? _c("div", { staticClass: "right" }, [
                          _c(
                            "span",
                            {
                              style:
                                _vm.approvalStatus.approvalType === "success"
                                  ? "font-size: 1.7em; color: green"
                                  : "font-size: 1.7em; color: red"
                            },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.approvalStatus.approvalType ===
                                      "success",
                                    expression:
                                      "approvalStatus.approvalType === 'success'"
                                  }
                                ],
                                staticClass: "fas fa-check-circle"
                              }),
                              _vm._v(" "),
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.approvalStatus.approvalType ===
                                        "warning" ||
                                      _vm.approvalStatus.approvalType ===
                                        "danger",
                                    expression:
                                      "approvalStatus.approvalType === 'warning' || approvalStatus.approvalType === 'danger'"
                                  }
                                ],
                                staticClass: "fas fa-times-circle"
                              })
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.data.property
                        ? _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.data.property.systemId || "-") +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("dashboard.merchant.accessNumber")) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.7em",
                            color: "CadetBlue"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-address-card" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.data.property
                        ? _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.data.property.password || "-") +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("dashboard.merchant.accessCode")) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.7em",
                            color: "CadetBlue"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-lock" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.data.property
                        ? _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.data.property.channelLine || "-") +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("dashboard.merchant.numberOfConnections")
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.7em",
                            color: "CadetBlue"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-plug" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.data.property
                        ? _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.data.property.channelLimit || "-") +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("dashboard.merchant.channelRate")) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.7em",
                            color: "CadetBlue"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-tachometer-alt" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.data
                        ? _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.data.MD5Key || "-") +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("dashboard.merchant.md5Key")) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.7em",
                            color: "CadetBlue"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-key" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("div", { staticClass: "left" }, [
                      _c(
                        "div",
                        { staticClass: "value" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", size: "mini" },
                              on: { click: _vm.redirectToDocs }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("dashboard.merchant.redirectToDocs")
                                ) + "\n                  "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("dashboard.merchant.goToDocs")) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.7em",
                            color: "CadetBlue"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-link" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.httpAPI
                  ? _c("div", { staticClass: "property" }, [
                      _c("div", { staticClass: "wrapper" }, [
                        _c("div", { staticClass: "left" }, [
                          _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.httpAPI) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$t("dashboard.merchant.HTTPAPIText")
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "1.7em",
                                color: "CadetBlue"
                              }
                            },
                            [_c("i", { staticClass: "fas fa-key" })]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.smppAPI
                  ? _c("div", { staticClass: "property" }, [
                      _c("div", { staticClass: "wrapper" }, [
                        _c("div", { staticClass: "left" }, [
                          _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.smppAPI) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$t("dashboard.merchant.SMPPAPIText")
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "1.7em",
                                color: "CadetBlue"
                              }
                            },
                            [_c("i", { staticClass: "fas fa-key" })]
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticClass: "info-right-col",
              attrs: { xs: 24, sm: 24, lg: 14 }
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "load-up card-softstyle",
                  staticStyle: { padding: "16px 16px 0" }
                },
                [
                  _vm.values.filter(function(v) {
                    return v !== 0
                  }).length
                    ? _c("bar-chart", {
                        ref: "barChart",
                        attrs: {
                          labels: _vm.labels,
                          values: _vm.values,
                          placeholder: _vm.$t(
                            "dashboard.merchant.numSuccesses"
                          ),
                          chartTitle: _vm.$t("dashboard.merchant.top5SmsSent")
                        }
                      })
                    : _c("div", [
                        _c("div", { staticClass: "graph-title" }, [
                          _vm._v(_vm._s(_vm.$t("dashboard.merchant.top5Pay")))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "no-data" }, [
                          _vm._v(_vm._s(_vm.$t("common.noData")))
                        ])
                      ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "card-section" },
                _vm._l(_vm.cardInfo, function(pair, i) {
                  return _c("CardInfo", { key: i, attrs: { pair: pair } })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }